/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Alerts_TypeInputs */

const es_billing_alerts_type = /** @type {(inputs: Billing_Alerts_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de alerta`)
};

const en_billing_alerts_type = /** @type {(inputs: Billing_Alerts_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alert type`)
};

/**
* | output |
* | --- |
* | "Alert type" |
*
* @param {Billing_Alerts_TypeInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_alerts_type = /** @type {((inputs?: Billing_Alerts_TypeInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Alerts_TypeInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_alerts_type(inputs)
	return en_billing_alerts_type(inputs)
});
export { billing_alerts_type as "billing.alerts.type" }